import progress from '@/assets/partners/progress.webp.asset.json';
import mydrop from '@/assets/partners/mydrop.webp.asset.json';
import racingLine from '@/assets/partners/racing-line.webp.asset.json';
import mywebglory from '@/assets/partners/mywebglory.webp.asset.json';
import kickoff from '@/assets/partners/kickoff.webp.asset.json';
import cbbc from '@/assets/partners/cbbc.webp.asset.json';
import tampaClub from '@/assets/partners/tampa-club.webp.asset.json';
import westTampa from '@/assets/partners/west-tampa.webp.asset.json';
import buschNails from '@/assets/partners/busch-nails2.webp.asset.json';
import kaiaBowls from '@/assets/partners/kaia-bowls.jpg.asset.json';
import pulse from '@/assets/partners/pulse.webp.asset.json';
import shaveCave from '@/assets/partners/shave-cave.webp.asset.json';
import crashLawyer from '@/assets/partners/crash-lawyer.webp.asset.json';
import ventoLaw from '@/assets/partners/vento-law.webp.asset.json';

const logos = [
  { src: progress.url, alt: 'Progress Construction & Insulation' },
  { src: crashLawyer.url, alt: 'The Crash Lawyer' },
  { src: ventoLaw.url, alt: 'Vento Law Firm' },
  { src: tampaClub.url, alt: 'The Tampa Club' },
  { src: westTampa.url, alt: 'West Tampa Tobacco Co.' },
  { src: racingLine.url, alt: 'The Racing Line' },
  { src: kaiaBowls.url, alt: 'Kaia Bowls' },
  { src: pulse.url, alt: 'Pulse' },
  { src: shaveCave.url, alt: 'The Shave Cave' },
  { src: buschNails.url, alt: 'Busch Nails and Lashes' },
  { src: cbbc.url, alt: 'Community Bible Baptist Church' },
  { src: mydrop.url, alt: 'Mydrop' },
  { src: mywebglory.url, alt: 'MyWebGlory' },
  { src: kickoff.url, alt: 'Kickoff' },
];

/** Full-bleed, edge-to-edge auto-scrolling partner logo banner. */
export const LogoMarquee = () => (
  <div className="w-screen relative left-1/2 -translate-x-1/2 overflow-hidden" role="img" aria-label="Logos of partner businesses we work with">
    <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex shrink-0" aria-hidden={dup === 1}>
          {logos.map((logo) => (
            <div
              key={`${dup}-${logo.alt}`}
              className="flex items-center justify-center px-6 md:px-10"
            >
              <img
                src={logo.src}
                alt={`${logo.alt} logo`}
                loading="lazy"
                decoding="async"
                width={160}
                height={64}
                className="h-12 md:h-16 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity"
              />
            </div>
          ))}
        </div>
      ))}
    </div>
  </div>
);